__turbopack_context__.v({
  "className": "open_sans_2f5b747e-module__dtG3gq__className",
  "variable": "open_sans_2f5b747e-module__dtG3gq__variable",
});
